import * as Yup from "yup";
import { stripHtml } from "../../../../util/html.utils";

type TFunc = (key: string, options?: Record<string, unknown>) => string;

export const createTextWithPagesElementPageFormSchema = (t: TFunc) =>
	Yup.object().shape({
		kind: Yup.string().required(t("validation:pageTypeRequired")),
		internalTitle: Yup.string().required(t("validation:titleFieldRequired")),
		image: Yup.object()
			.shape({
				id: Yup.string(),
			})
			.when("kind", {
				is: (kind: string) => {
					return (kind as unknown as string) === "ImagePageData";
				},
				then: (schema) =>
					schema.shape({
						id: Yup.string().required(t("validation:imageRequired")),
					}),
				otherwise: (schema) => schema.notRequired(),
			}),
		text: Yup.string()
			.transform((value) => {
				return stripHtml(value);
			})
			.max(1000, t("validation:textTooLong", { max: 1000 }))
			.when("kind", {
				is: (kind: string) => {
					return (kind as unknown as string) === "TextPageData";
				},
				then: (schema) => schema.required(t("validation:textFieldRequired")),
				otherwise: (schema) => schema.notRequired(),
			}),
	});
